import { createApiClient } from "@carepass/api-client";
import { createAsyncTaskRegistry } from "@carepass/async-task";
import { bearerToken, createSessionStore } from "@carepass/auth";
import { createRuntimeConfig, type RuntimeEnvironment } from "@carepass/config";
import { createAdminQueryClient } from "./query-client";
import { adminLoginPathAfterSessionEnd } from "./routes";
import { adminRouter } from "./router";
import { createAdminSessionLifecycle } from "./session-lifecycle";
import { createAdminUiStore } from "./stores/admin-ui-store";

const injectedEnvironment = (window as Window & { __CAREPASS_RUNTIME_CONFIG__?: RuntimeEnvironment }).__CAREPASS_RUNTIME_CONFIG__;

export const runtimeConfig = createRuntimeConfig({
  VITE_CAREPASS_PROFILE: import.meta.env.VITE_CAREPASS_PROFILE,
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_ASYNC_POLL_INITIAL_DELAY_MS: import.meta.env.VITE_ASYNC_POLL_INITIAL_DELAY_MS,
  VITE_ASYNC_POLL_MAX_DELAY_MS: import.meta.env.VITE_ASYNC_POLL_MAX_DELAY_MS,
  VITE_ASYNC_POLL_TIMEOUT_MS: import.meta.env.VITE_ASYNC_POLL_TIMEOUT_MS,
  ...injectedEnvironment,
}, window.location);

export const adminSessionStore = createSessionStore({
  scope: "admin",
  persistence: "tab",
  storage: window.sessionStorage,
  persistRefreshToken: false,
});

export const adminQueryClient = createAdminQueryClient();
export const adminUiStore = createAdminUiStore();
export const adminAsyncTasks = createAsyncTaskRegistry(window.sessionStorage);
export const adminSessionLifecycle = createAdminSessionLifecycle({
  sessionStore: adminSessionStore,
  queryClient: adminQueryClient,
  uiStore: adminUiStore,
  asyncTasks: adminAsyncTasks,
  onSessionEnded: (reason) => {
    const current = `${adminRouter.state.location.pathname}${adminRouter.state.location.search}`;
    void adminRouter.navigate(adminLoginPathAfterSessionEnd(reason, current), { replace: true });
  },
});
export const adminApiClient = createApiClient({
  baseUrl: runtimeConfig.apiBaseUrl,
  getAccessToken: () => bearerToken(adminSessionStore),
  onUnauthorized: () => adminSessionLifecycle.end("unauthorized"),
});

export const adminApplicationServices = {
  apiClient: adminApiClient,
  queryClient: adminQueryClient,
  uiStore: adminUiStore,
  sessionLifecycle: adminSessionLifecycle,
  asyncTasks: adminAsyncTasks,
  polling: runtimeConfig.polling,
};
